
import { computed, defineComponent, ref, toRaw, watch } from "vue";
import { getCSSVariableValue } from "@/assets/ts/_utils";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import store from "@/store";
import MBloader from "@/components/MBLoader.vue";

export default defineComponent({
  name: "widget-case-manager",
  props: {
    widgetClasses: String,
    chartColor: String,
    chartHeight: String,
  },
  components: {
    MBloader,
  },
  setup() {
    let patient_values = ref([]);
    const store = useStore();
    const isLoaded = ref<boolean>(false);

    const getInformation = () => {
      isLoaded.value = false;
      const pd = store.getters.getPatientValues;

      if (!pd.schedule_link) {
        const scheduleBaseUrl =
          "https://meetings.hubspot.com/massivebio/cancer-treatment-consultation";
        pd.schedule_link = `${scheduleBaseUrl}?email=${pd.patient_s_email}&firstname=${pd.first_name}&lastname=${pd.last_name}&phone=${pd.patient_s_phone}`;
      }

      patient_values.value = pd;
      isLoaded.value = true;
    };

    /*watch(
      () => store.getters.getPatientValues,
      function (sd) {
        if (!sd) {
          store.dispatch(Actions.GET_PATIENT_VALUES, {
          });
        }
        const pd = toRaw(sd);
        patient_values.value = pd;
        schedule_a_call.value = 'https://meetings.hubspot.com/massivebio/cancer-treatment-consultation?email='+pd.patient_s_email+'&firstname='+pd.first_name+'&lastname='+pd.last_name+'&phone='+pd.patient_s_phone;
      }
    );*/

    return {
      patient_values,
      getInformation,
      isLoaded,
    };
  },
});
